import { __awaiter, __generator } from "tslib";
import { getTextDecoder } from './getTextDecoder';
import { getTextEncoder } from './getTextEncoder';
export function utf8Encode(value) {
    return __awaiter(this, void 0, void 0, function () {
        var encoder;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getTextEncoder()];
                case 1:
                    encoder = _a.sent();
                    return [2 /*return*/, encoder.encode(value)];
            }
        });
    });
}
export function utf8Decode(value) {
    return __awaiter(this, void 0, void 0, function () {
        var decoder;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getTextDecoder()];
                case 1:
                    decoder = _a.sent();
                    return [2 /*return*/, decoder.decode(value)];
            }
        });
    });
}
//# sourceMappingURL=api.js.map